import { smetaModals } from "../../MainPage/Tools/modalManager";
import React from "react";
import { getModalSectionID, getStyleWindow } from "../../MainPage/Tools/Tools";
import { resumeRequest } from "../TokenProcessing";
import DialogKldr from "../../MainPage/Module/Dialogs/DialogKldr";

interface Data {
  json: {
    Params: {
      ObjType?: string;
      Module?: string;
      ObjRef?: string;
      RequestID?: string;
      OnlyView?: string;
      MultiSel?: string;
      Level?: string;
      Code?: string;
      RecordIndex?: string;
      Title?: string;
    };
    CLSID?: string;
    Title?: string;
    Module?: string;
  };
  subData: {
    props: any;
    func: (data: any) => any;
    from: string;
  };
  requestID: string;
}

export const addressEditKladrObj = (data: Data) => {
  const { json, subData, requestID } = data;
  if (json.Params) {
    smetaModals.open(
      <DialogKldr
        Module={json.Module}
        ObjType={json.Params.Level}
        Code={json.Params.Code}
        RecordIndex={json.Params.RecordIndex && Number(json.Params.RecordIndex) >= 0 ? json.Params.RecordIndex : "0"}
        RequestID={json.Params.RequestID}
        data={subData}
        SectionID={getModalSectionID()}
        func={subData.func}
      />,
      {
        Title: json.Params.Title,
        style: getStyleWindow(),
        onClose: () => {
          subData.props?.input?.current?.focus();
          resumeRequest(json.Params.RequestID, subData, {});
        },
      },
    );
  }
};
